// RostersPage — Phase 2 / Step C-3.3 Pass 2 Batch A: the roster editor
// body and create-modal physically moved to
// shared/widgets/scenario_os/RosterEditor.jsx. This page is now a thin
// learner-app wrapper that mounts CoachLayout and injects the
// learner-app `rosterAPI` / `coachAPI` singletons plus the overlay
// confirm/toast helpers.
import React from 'react';
import CoachLayout from './CoachLayout';
import RosterEditor from '../../../../shared/widgets/scenario_os/RosterEditor.jsx';
import { rosterAPI, coachAPI } from '../../services/api';
import { confirm, toast } from '../../../../shared/utils/overlays';
import './scene_designer.css';

export default function RostersPage() {
  return (
    <CoachLayout title="Rosters">
      <RosterEditor
        rosterAPI={rosterAPI}
        coachAPI={coachAPI}
        confirm={confirm}
        toast={toast}
      />
    </CoachLayout>
  );
}
